import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cash",
  "use": "cash-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"cash\"><rect width=\"12.21\" height=\"8.019\" x=\"2.383\" y=\"4.307\" stroke=\"#333\" stroke-width=\"2\" rx=\"2\" /><path stroke=\"#333\" stroke-width=\"2\" d=\"M6.358 16.297h9.044a3 3 0 0 0 3-3v-4.98\" /><path fill=\"#333\" d=\"M8.488 10.665a2.349 2.349 0 1 0 0-4.697 2.349 2.349 0 0 0 0 4.697Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol